import { jsx as _jsx } from "react/jsx-runtime";
import { StyledParagraph } from './styles';
export var Paragraph = function (_a) {
  var children = _a.children;
  return _jsx(StyledParagraph, {
    el: "p",
    styleName: "bodyRegular",
    children: children
  });
};